module.exports = __webpack_public_path__ + "public/SiteIcons/darkIconWhite.svg?c4e8bec6";